module.exports = __webpack_public_path__ + "img/main-logo.307f549a.svg";